'use client';

import { Badge } from '@packages/shared/src/ui/Badge/Badge';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useBasketLink } from '../../shared/useBasketLink';

export const BasketLink = () => {
  const { href, ariaLabel, label, badgeCount } = useBasketLink();

  const icon = <span className="icon-emp-cart size-4" aria-hidden />;

  return (
    <SlotEquivalentLinksItem href={href} ariaLabel={ariaLabel}>
      {badgeCount ? <Badge badgeContent={badgeCount}>{icon}</Badge> : icon}
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
